export const LANGUAGE_VERSIONS = {
  java: "15.0.2",
  javascript: "20.11.1",
  cpp: "10.2.0",
  python: "3.11.0",
  sql: "3.36.0",
};

export const CODE_SNIPPETS = {
  java: ``,
  javascript: ``,
  cpp: ``,
  python: ``,
  sql: ``,
};
